import type { Message } from '@/modules/chatting/types'
import { calculateImageSize } from '@/modules/vault/utils'

interface Props {
  story: NonNullable<Message['story']>
  className?: string
}

const MAX_STORY_WIDTH = 200
const MAX_STORY_HEIGHT = 300

export const ChatMessageStory = ({ story, className }: Props) => {
  const media = story.media?.[0]

  if (!media?.files.thumb) return null

  const { width, height, url } = media.files.thumb
  const dimensions = calculateImageSize(
    width,
    height,
    MAX_STORY_WIDTH,
    MAX_STORY_HEIGHT,
  )

  return (
    <div className={className}>
      <div
        className="overflow-hidden"
        style={dimensions}
      >
        <img
          src={url}
          alt="story"
          className="h-full w-full object-cover"
        />
      </div>
      <div className="mb-1 text-xs text-secondary-300">Replied to story</div>
    </div>
  )
}
